<!-- 企业入驻信息 -->
<style lang="scss" scoped>
.company-item-wrapper {
  background: #ffffff;

  .company-item-upload-box {
    display: flex;
    gap: 10px;

    .label {
      display: flex;
      justify-content: space-between;
    }
  }

  .required {
    &::before {
      content: '*';
      color: #ff0000;
      margin-right: 4px;
    }
  }

  .example {
    height: 28px;
    color: $color-primary;
    cursor: pointer;
    border-bottom: 1px solid $color-primary;
    a {
      color: $color-primary;
    }
  }
}

.no-show-star {
  :deep() {
    .el-form-item__label {
      width: 100% !important;
      text-align: end;
      height: 22px;
      &::before {
        content: '' !important;
      }
    }
  }
}
</style>

<template>
  <div class="company-item-wrapper">
    <el-form ref="formRef" :model="form" :rules="rules" size="large" label-position="top" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="required mb-4px">
            上传证照(系统将自动识别填写证件信息，请核对识别结果，如有错误请手动修改。图片格式支持jpg/jpeg/png，单张图片大小不超过2M)
          </div>
          <div class="company-item-upload-box">
            <el-form-item label="" prop="agentIdentityCardFrontUrl">
              <div>
                <img-upload
                  v-model="form.agentIdentityCardFrontUrl"
                  :dir="OSS_DIR.ID_CARD"
                  height="160"
                  :disabled="!!form.equalLegal"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrIdentityCardFront"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">经办人身份证人像面</span>
                  <span class="example" @click="preview(OssFile.IDENTITY_CARD_FRONT_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="agentIdentityCardBackUrl">
              <div class="">
                <img-upload
                  v-model="form.agentIdentityCardBackUrl"
                  :dir="OSS_DIR.ID_CARD"
                  :disabled="!!form.equalLegal"
                  height="160"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrIdentityCardBack"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">经办人身份证国徽面</span>
                  <span class="example" @click="preview(OssFile.IDENTITY_CARD_BACK_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="12">
          <el-form-item label="经办人证件类型" prop="agentCardType">
            <el-select v-model="form.agentCardType" :disabled="!!form.equalLegal" placeholder="请选择证件类型">
              <el-option v-for="item in ID_TYPE_LIST" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="经办人姓名" prop="agentName">
            <el-input v-model="form.agentName" :disabled="!!form.equalLegal" placeholder="请输入经办人姓名" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="经办人证件号码" prop="agentIdentityCard">
            <el-input v-model="form.agentIdentityCard" :disabled="!!form.equalLegal" placeholder="请输入经办人证件号码" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="经办人电子邮箱" prop="agentEmail">
            <el-input v-model="form.agentEmail" placeholder="请输入经办人电子邮箱" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="经办人证件有效期" prop="agentIdentityCardFromDate">
            <el-date-picker
              v-model="form.agentIdentityCardFromDate"
              :disabled="!!form.equalLegal"
              style="width: 100%"
              type="date"
              value-format="YYYY-MM-DD"
              placeholder="开始日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="no-show-star">
            <el-form-item prop="agentIdentityCardEndDate">
              <template #label>
                <el-checkbox
                  v-model="form.agentIdentityCardLongTerm"
                  class="long-term-checkbox"
                  :disabled="!!form.equalLegal"
                  label="结束日期：长期"
                  :true-label="1"
                  :false-label="0"
                  name="type"
                  @change="
                    (e) => {
                      longChange(e, 'agentIdentityCardEndDate')
                    }
                  "
                />
              </template>
              <el-date-picker
                v-model="form.agentIdentityCardEndDate"
                style="width: 100%"
                :disabled="!!form.agentIdentityCardLongTerm || !!form.equalLegal"
                type="date"
                value-format="YYYY-MM-DD"
                placeholder="结束日期"
              />
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="8">
          <el-form-item label="经办人手机号" prop="agentPhone">
            <el-input v-model="form.agentPhone" :disabled="!!form.equalLegal" placeholder="请输入经办人手机号" />
          </el-form-item>
        </el-col>

        <el-col v-if="!form.equalLegal" :span="8">
          <el-form-item label="授权人委托书加盖公章的复印件扫描件" prop="agentAuthUrl">
            <img-upload
              v-model="form.agentAuthUrl"
              :dir="OSS_DIR.POWER_OF_ATTORNEY"
              height="160"
              width="100%"
              :size-limit="2"
              accept="image/jpg,image/jpeg,image/png"
            >
              <template #empty>
                <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
              </template>
            </img-upload>
          </el-form-item>
          <div class="example inline-block" style="height: 22px">
            <a class="example-text" :href="OssFile.POWER_OF_ATTORNEY" target="_blank" rel="noopener noreferrer">下载授权委托书</a>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <ImgViewer v-model:visible="showImgViewer" :url-list="currentUrlList" :show-mini-image="false" :prev-btn="false" :next-btn="false" />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { ID_TYPE_LIST, OSS_DIR } from '@/constants/common'
import OssFile from '@/constants/oss-file'
import userApi from '@/apis/user'
import { isPhone, validateEmail, validateIDNumber } from '@/common/js/validator'
import { dealTime } from '@/utils/utils'
import { identifyEmpty } from './data'

const showImgViewer = ref(false)
const currentUrlList = ref([])
const preview = (url) => {
  showImgViewer.value = true
  currentUrlList.value = [url]
}
const form = ref({
  agentIdentityCardFrontUrl: null, // 经办人身份证人像面
  agentIdentityCardBackUrl: null, // 经办人身份证国徽面
  agentCardType: 101, // 证件类型
  agentIdentityCard: '', //证件号码
  agentIdentityCardFromDate: '', // 开始日期
  agentIdentityCardEndDate: '', // 结束日期
  agentIdentityCardLongTerm: 0, // 是否长期
  agentName: '', //经办人姓名
  agentPhone: '', // 经办人手机号
  agentEmail: '', // 经办人电子邮箱
  agentAuthUrl: null, // 授权人委托书加盖公章的复印件扫描件
  equalLegal: 0, // 是否同法人
})

const emit = defineEmits(['setFormData'])

const props = defineProps({
  joinForm: {
    type: Object,
    default: () => {},
  },
})

watch(
  () => form.value,
  (newVal) => {
    //更新joinForm
    emit('setFormData', newVal)
  },
  { deep: true },
)

watch(
  () => props.joinForm,
  (newVal) => {
    if (newVal) {
      //只设置form中存在的字段
      for (const key in newVal) {
        if (newVal[key] !== undefined && newVal[key] !== null && key in form.value) {
          form.value[key] = newVal[key]
        }
      }
    }
  },
  { deep: true, immediate: true },
)

// 自定义法人证件号验证规则
const checkAgentIdentityCard = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入经办人证件号码'))
  }
  if (!validateIDNumber(value)) {
    return callback(new Error('输入经办人证件号码格式不对'))
  }
  callback()
}
// 自定义经办人身份证结束日期检验规则
const checkAgentIdentityCardEndDate = (rule, value, callback) => {
  if (form.value.agentIdentityCardFromDate && value && dealTime(form.value.agentIdentityCardFromDate) > dealTime(value)) {
    callback(new Error('结束日期不能小于开始日期'))
  } else if (value || form.value.agentIdentityCardLongTerm) {
    callback()
  } else {
    callback(new Error('请选择结束日期'))
  }
}

// 自定义手机号码验证规则
const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号码'))
  }
  if (!isPhone(value)) {
    return callback(new Error('输入手机号码格式不对'))
  }
  callback()
}

// 自定义法人邮箱验证规则
const checkAgentEmail = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入经办人电子邮箱'))
  }
  if (!validateEmail(value)) {
    return callback(new Error('输入经办人电子邮箱格式不对'))
  }
  callback()
}

//长期赋值
const longChange = (e, key) => {
  e ? (form.value[key] = '2099-12-31') : (form.value[key] = '')
}

const rules = ref({
  agentName: [{ required: true, message: '请输入经办人姓名', trigger: ['blur', 'change'] }],
  agentIdentityCard: [
    {
      required: true,
      validator: checkAgentIdentityCard,
      trigger: ['blur', 'change'],
    },
  ],
  agentCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
  agentIdentityCardFromDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
  agentIdentityCardEndDate: [
    {
      required: true,
      validator: checkAgentIdentityCardEndDate,
      trigger: 'change',
    },
  ],
  agentPhone: [
    {
      required: true,
      validator: checkPhone,
      trigger: ['blur', 'change'],
    },
  ],
  agentEmail: [
    {
      required: true,
      validator: checkAgentEmail,
      trigger: ['blur', 'change'],
    },
  ],
  agentAuthUrl: [{ required: true, message: '请上传授权委托书正面图片', trigger: 'none' }],
  agentIdentityCardFrontUrl: [{ required: true, message: '请上传经办人身份证人像面', trigger: 'none' }],
  agentIdentityCardBackUrl: [{ required: true, message: '请上传经办人身份证国徽面', trigger: 'none' }],
})

const formRef = ref(null) // 表单ref

//身份证正面ocr识别
const postOcrIdentityCardFront = async (url) => {
  form.value.agentIdentityCardFrontUrl = url
  if (!url) return
  const res = await userApi.postIdCardFrontOcr({
    identityCardFrontUrl: url,
  })
  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)

  emit('setFormData', {
    agentName: res.name,
    agentIdentityCard: res.identityCard,
  })
}

//身份证反面ocr识别
const postOcrIdentityCardBack = async (url) => {
  form.value.agentIdentityCardBackUrl = url
  if (!url) return
  const res = await userApi.postIdCardBackOcr({
    identityCardBackUrl: url,
  })
  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)

  emit('setFormData', {
    agentIdentityCardFromDate: res.identityCardFromDate, // 开始日期
    agentIdentityCardEndDate: res.identityCardEndDate, // 结束日期
    agentIdentityCardLongTerm: res.identityCardLongTerm, // 是否长期
  })
}

//经办人同法人数据更新
const updateEqualLegalData = (data) => {
  Object.assign(form.value, data)
  data.agentIdentityCardEndDate && formRef.value.clearValidate(['agentIdentityCardEndDate'])
}

defineExpose({
  form: computed(() => form.value),
  updateEqualLegalData,
  validate: () => {
    return formRef.value?.validate()
  },
})
</script>
